import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DataServer } from "../../../../sensorconfig.axios";

interface AverageAndPeakSpeedStatisticsState {
  AverageAndPeakSpeedStatistics: {
    load: boolean;
    data: [];
  };
}

export const AverageAndPeakSpeedStatisticsSlice = createSlice({
  name: "AverageAndPeakSpeedStatistics",
  initialState: {
    AverageAndPeakSpeedStatistics: {
      load: false,
      data: [],
    },
  } as AverageAndPeakSpeedStatisticsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAverageAndPeakSpeedStatistics.pending, (state) => {
        state.AverageAndPeakSpeedStatistics.load = true;
      })
      .addCase(getAverageAndPeakSpeedStatistics.fulfilled, (state, action) => {
        state.AverageAndPeakSpeedStatistics.data = action.payload;
        state.AverageAndPeakSpeedStatistics.load = false;
      })
      .addCase(getAverageAndPeakSpeedStatistics.rejected, (state) => {
        state.AverageAndPeakSpeedStatistics.load = false;
      });
  },
});

export default AverageAndPeakSpeedStatisticsSlice.reducer;

export const getAverageAndPeakSpeedStatistics = createAsyncThunk(
  "AverageAndPeakSpeedStatistics/getAverageAndPeakSpeedStatistics",
  async (param: any, thunkAPI) => {
    try {
      var data: any; 
      if(param.apiParam.operator_id === "all"){
        data = await DataServer.get("/api/management/mheSummary/v1/getAverageAndPeakSpeedStatistics?warehouse_id=" + param.apiParam.warehouse_id + "&mhe_id=" + param.apiParam.mhe_id + "&duration=" + param.apiParam.duration);
      } else {
        data = await DataServer.get("/api/management/mheSummary/v1/getAverageAndPeakSpeedStatistics?warehouse_id=" + param.apiParam.warehouse_id + "&mhe_id=" + param.apiParam.mhe_id + "&duration=" + param.apiParam.duration + "&operator_id=" + param.apiParam.operator_id);
      }
      return data.data;
    } catch (error) {
      return error;
    }
  }
);
